import React from 'react';
import Setting from "../../../components/pages/form/Setting/BaseSetting/Setting";

const SettingPage = () => {
    return <Setting />
};

export default SettingPage;